(() => {
  const SELECTOR = '[data-jpc-media-carousel]';

  function setupCarousel(carousel) {
    if (!carousel || carousel.dataset.jpcCarouselReady === 'true') return;

    const track = carousel.querySelector('[data-jpc-carousel-track]');
    const previous = carousel.querySelector('[data-jpc-carousel-prev]');
    const next = carousel.querySelector('[data-jpc-carousel-next]');
    if (!track || !previous || !next) return;

    carousel.dataset.jpcCarouselReady = 'true';

    const getStep = () => {
      const item = track.querySelector('.jpc-tab-media');
      if (!item) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return item.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const hasOverflow = maxScroll > 2;
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      previous.disabled = !hasOverflow || track.scrollLeft <= 2;
      next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
    };

    previous.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(update);
      observer.observe(track);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    requestAnimationFrame(update);
  }

  function init(root = document) {
    if (root.matches?.(SELECTOR)) setupCarousel(root);
    root.querySelectorAll?.(SELECTOR).forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
